import { Text } from '@optiaxiom/react';

const formatParameters = (parameters: Record<string, unknown>) => {
  const jsonString = JSON.stringify(parameters);
  // Truncate if longer than 50 characters
  if (jsonString.length > 50) {
    return jsonString.substring(0, 47) + '...';
  }
  return jsonString;
};

export function ParametersCell({ parameters }: { parameters: Record<string, unknown> }) {
  return (
    <Text fontSize="md" fontFamily="mono" title={JSON.stringify(parameters, null, 2)}>
      {formatParameters(parameters)}
    </Text>
  );
}
